
import logo from "../assets/svg/logo.svg"
import Rectangle from "../assets/svg/Rectangle.svg"
import ittelecom from "../assets/svg/ittelecom.svg"
import Retail from "../assets/svg/Retail.svg"
import oil from "../assets/svg/oil.svg"
import textcardicon from "../assets/svg/text-card-icon.svg"
import arow1 from "../assets/svg/arow1.svg"
import arow2 from "../assets/svg/arow2.svg"
import arow3 from "../assets/svg/arow3.svg"
import employes from "../assets/svg/employes.svg"
import employerighticon from "../assets/svg/employerighticon.svg"
import employes2icon from "../assets/svg/employes2icon.svg"
import employes3icon from "../assets/svg/employes3icon.svg"
import employes4icon from "../assets/svg/employes4icon.svg"
import Mask from "../assets/svg/Mask .svg"
import hricon from "../assets/svg/hricon.svg"
import aboutusicon from "../assets/svg/aboutus-icons.jpg"
import aboutus2icon from "../assets/svg/aboutus-2icon.jpg"
import aboutus4 from "../assets/svg/aboutus4.svg"
import aboutusvideo from "../assets/svg/aboutus-video.svg"
import johnicon from "../assets/svg/johnicon.svg"
import johniconss from "../assets/svg/johniconss.png"

import roundserviceicon from "../assets/svg/roundserviceicon.svg"
import footer from "../assets/svg/footer.svg"
import vision from "../assets/svg/vision.svg"
import mission from "../assets/svg/mission.svg"
import global from "../assets/svg/global.svg"
// import zeroone from "../assets/svg/01.svg"
import overservice1 from "../assets/svg/overservice1.svg"
import overservice2 from "../assets/svg/overservice2.svg"
import overservice3 from "../assets/svg/overservice3.svg"
import overservice4 from "../assets/svg/overservice4.svg"
import overservice5 from "../assets/svg/overservice5.svg"
import pogres1 from "../assets/svg/pogres1.svg"
import pogres2 from "../assets/svg/pogres2.svg"
import pogres3 from "../assets/svg/pogres3.svg"
import pogres4 from "../assets/svg/pogres4.svg"
import pogres5 from "../assets/svg/pogres5.svg"
import pogres6 from "../assets/svg/pogres6.svg"
import pogres7 from "../assets/svg/pogres7.svg"
import map from "../assets/svg/map.svg"
import foterlogo from "../assets/svg/foterlogo.svg"
import servicehader1 from "../assets/svg/servicehader1.svg"
import servicehader2 from "../assets/svg/servicehader2.svg"
import hrsolutionvideoicon from "../assets/svg/hrsolutionvideoicon.svg"
import hrhomecard from "../assets/svg/hrhomecard.svg"
import candidatehome from "../assets/svg/candidatehome.svg"
import volumehome from "../assets/svg/volumehome.svg"
import recruitmenthome from "../assets/svg/recruitmenthome.svg"
import executivehome from "../assets/svg/executivehome.svg"
import textcardicons from "../assets/svg/textcardicons.svg"
import homecard from "../assets/svg/homecard.svg" 
import Telecom from "../assets/svg/Telecom.svg"
import Healthcare from "../assets/svg/Healthcare.svg"
import Engineering from  "../assets/svg/Engineering.svg"
import Manufacturing from "../assets/svg/Manufacturing.svg"
import Logistics from "../assets/svg/Logistics.svg"
import  Finance from "../assets/svg/Finance.svg"
import Hospitality from "../assets/svg/Hospitality.svg"
import carogelcard1 from "../assets/svg/carogelcard1.svg"
import cvarogel2 from "../assets/svg/cvarogel2.svg"
import cvarogel3 from "../assets/svg/cvarogel3.svg"
import cvarogel4 from "../assets/svg/cvarogel4.svg"
import cvarogel5 from "../assets/svg/cvarogel5.svg"
import logomain from "../assets/svg/logomain.png"

import tsm from "../assets/svg/tsm.svg"
import one from "../assets/svg/one.svg"
import three from "../assets/svg/three.svg"
import boll from "../assets/svg/boll.svg"
import chair from "../assets/svg/chair.svg"
import industry from "../assets/svg/industry.svg"
import employeiconcard from "../assets/svg/employeiconcard.svg"
import tabvricon from "../assets/svg/tabvricon.svg"
import cloud from "../assets/svg/cloud.svg"
import finanes from "../assets/svg/finanes.svg"
import hospitalitysvg from "../assets/svg/hospitalitysvg.svg"
import healthicons from "../assets/svg/healthicons.svg"
import material from "../assets/svg/material.svg"
import manufacturingsvg from "../assets/svg/manufacturingsvg.svg"
import logistic from "../assets/svg/logistic.svg"
import hugeicons from "../assets/svg/hugeicons.svg"
import retailbulding from "../assets/svg/retailbulding.svg"
import oilindustry from "../assets/svg/oilindustry.svg"
import food from "../assets/svg/food.svg"
import employeiconcard2 from "../assets/svg/employeiconcard2.svg"
import serviceicon from "../assets/svg/serviceicon.svg"
import apllication from "../assets/svg/apllication.svg"
import hrsolutionvideoicon2 from "../assets/svg/hrsolutionvideoicon2.svg"
import hrsolutionicon from "../assets/svg/hrsolutionicon.svg"
import servicehader3 from "../assets/svg/servicehader3.svg"
import servicehader4 from "../assets/svg/servicehader4.svg"
import textcardiconsmobile from "../assets/svg/textcardiconsmobile.svg"
import toggle from "../assets/svg/toggle.svg"
import toggleclose from "../assets/svg/toggleclose.svg"
import aboutus2iconresponsive from "../assets/svg/aboutus2iconresponsive.svg"
import filter from "../assets/svg/filter.svg"
import arowfilters from "../assets/svg/arowfilters.svg"
import buldingcard  from "../assets/svg/buldingcard.svg"
import foodimg from "../assets/svg/foodimg.svg"
import fulltime from "../assets/svg/fulltime.svg"
import Remote from "../assets/svg/Remote.svg"
import homebaner from "../assets/svg/homebaner.svg"

const Images = {
    Remote,
    hrsolutionvideoicon2,
    hrsolutionicon,
    fulltime,
    foodimg,
    buldingcard,
    homebaner,
    filter,
    arowfilters,
    aboutus2iconresponsive,
    apllication,
    servicehader3,
    servicehader4,
    serviceicon,
    toggleclose,
    textcardiconsmobile,
    one,
    toggle,
    food,
    healthicons,
    employeiconcard2,
    retailbulding,
    oilindustry,
        manufacturingsvg,
    hugeicons,
    logistic,
    material,
    tabvricon,
    hospitalitysvg,
    finanes,
    cloud,
    hrsolutionvideoicon,
    employeiconcard,
    logo,
    logomain,
    boll,
    industry,
    tsm,
    chair,
    three,
    cvarogel2,
    cvarogel3,
    cvarogel4,
    cvarogel5,
    Telecom,
    Healthcare,
    carogelcard1,
    Hospitality,
    Finance,
    Manufacturing,
    Logistics,
    hrhomecard,
    Engineering, 
    homecard,
    recruitmenthome,
    executivehome,
    johniconss,
    candidatehome,
    foterlogo,
    volumehome,
    map,
    Rectangle,
    ittelecom,
    Retail,
    oil,
    textcardicon,
    textcardicons,
    arow1,
    arow2,
    arow3,
    employes,
    employerighticon,
    employes2icon,
    employes3icon,
    employes4icon,
    Mask,
    hricon,
    aboutusicon,
    aboutus2icon,
    aboutus4,
    aboutusvideo,
    johnicon,
    roundserviceicon,
    footer,
    vision,
    mission,
    global,
    overservice1,
    overservice2,
    overservice3,
    overservice4,
    overservice5,
    pogres1,
    pogres2,
    pogres3,
    pogres4,
    pogres5,
    pogres6,
    pogres7,
    servicehader1,
    servicehader2




}
export default Images;
